$(document).ready(function () {
    $('.symbol-count').on('keyup input', function() {
        countSymbols($(this));
    });

    const countSymbols = (el) => {
        el.siblings('.current-number').text(el.val().length);
        if(el.val().length === 0) {
            el.siblings('.current-number').removeClass('green-text').addClass('grey-text');
        } else {
            el.siblings('.current-number').addClass('green-text').removeClass('grey-text');
        }
    }

    $('.symbol-count').each(function() {
        countSymbols($(this));
    });

    $('.js-create-article-project').on('click', 'li a', function () {
        $(this).closest('.js-create-article-project').find('input[type=hidden]').val($(this).attr('data-id'));
    });

    $('.article-form').on('submit', function() {
        if ($(this).find('.js-is-content:checked')) {
            if ($('#text-editor').attr('data-min')) {
                if(parseInt($('.for-textarea .current-number').text()) < $('#text-editor').attr('data-min')) {
                    $('#text-editor-error').show();
                }
            }
            if ($('#text-editor').attr('data-max')) {
                if(parseInt($('.for-textarea .current-number').text()) > $('#text-editor').attr('data-min')) {
                    if ($('.wrap_container').find('[data-popup=textLimitError]')) {
                        $('[data-popup=textLimitError]').click();
                    } else {
                        $('.wrap_container').append('<a href="#" class="open-popup" data-popup="textLimitError"></a>');
                        $('[data-popup=textLimitError]').click();
                    }

                }
            }
        }
    });

    $('.js-is-content').on('change', function() {
        var form = $(this).closest('form');
        if ($(this).prop('checked')) {
            $(form).find('.js-is-content-hide').hide();
            $(form).find('#announcement_text').attr('required', false);
            $(form).find('#text-editor').attr('data-min', "-10");
        } else {
            $(form).find('.js-is-content-hide').show();
            $(form).find('#announcement_text').attr('required', true);
            $(form).find('#text-editor').attr('data-min', "0");
        }
    });

    $('.js-create-article-list').on('click', 'li', function() {
        var $this = $(this);
        var id = $(this).attr('data-id');
        var url = $('.js-create-article-list').attr('data-action');
        var req = $.ajax({
            method: 'post',
            url: url,
            data: {'id': id, '_token': CSRF_TOKEN},
        });
        req.then(function(resp) {
            if (resp.success) {
                if (resp.article) {
                    var article = resp.article;
                    $this.closest('form').find('input[name=article_id]').val(article.id);
                    $this.closest('form').find('input[name=title]').val(article.title);
                    countSymbols($this.closest('form').find('input[name=title]'));
                    var publicaion_url = article.url ? article.url : translit(article.title);
                    $this.closest('form').find('input[name=publicaion_url]').val(publicaion_url);
                    countSymbols($this.closest('form').find('input[name=publicaion_url]'));
                    $this.closest('form').find('textarea[name=announce]').text(article.announce);
                    $this.closest('form').find('input[name=meta_title]').val(article.meta_title);
                    $this.closest('form').find('textarea[name=meta_description]').text(article.meta_description);
                    $this.closest('form').find('input[name=meta_keywords]').val(article.meta_keywords);
                    tinyMCE.get('text-editor').setContent(article.text);
                }
            }
        });
    });

    $('.draftSaved, .draftSent').on('click', function() {
        tinyMCE.triggerSave();
        if ($('#text-editor').attr('data-min')) {
            if(parseInt($('.for-textarea .current-number').text()) <= parseInt($('#text-editor').attr('data-min'))) {
                $('#text-editor-error').show();
                $('html, body').animate({
                    scrollTop: $('.for-textarea').offset().top - 150
                }, 500);
                return false;
            }
        }
        if ($('#text-editor').attr('data-max')) {
            if(parseInt($('.for-textarea .current-number').text()) > parseInt($('#text-editor').attr('data-max'))) {
                if ($('.wrap_container').find('[data-popup=textLimitError]').length) {
                    $('[data-popup=textLimitError]').click();
                } else {
                    $('.wrap_container').append('<a href="#" class="open-popup" data-popup="textLimitError"></a>');
                    $('[data-popup=textLimitError]').click();
                }
                return false;
            }
        }
        if($(this).closest('form').valid()) {
            $(this).closest('form').find(['type=submit']).attr('disabled', true);
            var $this = $(this);
            var data = $(this).closest('form').serializeArray();
            var url = $(this).closest('form').attr('action');
            data.push({name: $(this).attr('data-value'), value: 1});

            var req = $.ajax({
                method: 'post',
                url: url,
                data: data,
            });
            req.done(function(resp) {
                if (resp.success) {
                    if (resp.article && resp.article.href) {
                        location.href = resp.article.href;
                    }
                }
                else if (resp.links_count_error) {
                    if ($('.wrap_container').find('[data-popup=linksCountError]').length) {
                        $('[data-popup=linksCountError]').click();
                    } else {
                        $('.wrap_container').append('<a href="#" class="open-popup" data-popup="linksCountError"></a>');
                        $('[data-popup=linksCountError]').click();
                    }
                }
                else if (resp.images_count_error) {
                    if ($('.wrap_container').find('[data-popup=imagesCountError]').length) {
                        $('[data-popup=imagesCountError]').click();
                    } else {
                        $('.wrap_container').append('<a href="#" class="open-popup" data-popup="imagesCountError"></a>');
                        $('[data-popup=imagesCountError]').click();
                    }
                }
            })
            req.fail(function(error) {
                var errors = $.parseJSON(error.responseText);
                $.each(errors.errors, function(key, value) {
                    $($this).closest('form').find('input[name='+key+']').addClass('error');
                    $($this).closest('form').find('input[name='+key+']').after('<label id="'+key+'-error" class="error" for="'+key+'">'+value+'</label>');
                });
            })
            req.always(function() {
                $($this).closest('form').find('[type=submit]').attr('disabled', false);
            });
        }
    });


    //Deleting articles
    var $beforeDeletingArticle;
    $('.wrap_content').on('click', '.control-panel_item_delete.open-popup[data-popup=beforeDeletingArticle]', function() {
        $beforeDeletingArticle = $(this);
        $('#beforeDeletingArticle .confirm-btn').on('click', function() {
            var req = $.ajax({
                method: 'post',
                url: $('#beforeDeletingArticle').attr('data-action'),
                data: {'id': $beforeDeletingArticle.attr('data-id'), '_token': CSRF_TOKEN},
            });
            req.then(function(resp) {
                if (resp.success) {
                    $beforeDeletingArticle.closest('.control-panel_item_product').remove();
                    $(this).closest('.wrap_popup').find('.close').trigger('click');
                }
            });
        });
    });

    function translit(text) {
        var pairs = {
            // ru_RU
            'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e',
            'ё': 'e', 'ж': 'j', 'з': 'z', 'и': 'i', 'й': 'i', 'к': 'k',
            'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o', 'п': 'p', 'р': 'r',
            'с': 's', 'т': 't', 'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'c',
            'ч': 'ch', 'ш': 'sh', 'щ': 'sch', 'ъ': '-', 'ы': 'y', 'ь': '',
            'э': 'e', 'ю': 'yu', 'я': 'ya',
            // uk_UA
            'ґ': 'g', 'є': 'ye', 'і': 'i', 'ї': 'yi', '\'': '', '`': ''
        };
        text = text.toLowerCase();
        var res = '';
        for (var i = 0; i < text.length; i++) {
            if (text[i] in pairs) {
                res += pairs[text[i]];
            } else if (text[i].match(/^[0-9]+$/)) {
                res += text[i];
            } else {
                res += text[i].match(/^[a-z_-]+$/) ? text[i] : '-';
            }
        }
        res = res.replace(/cz(?=i|e|y|j)/g, "c");
        res = res.replace(/[-]+/g, '-');
        res = res.replace(/^[-]+|[-]+$/g, '');

        return res;
    };

    $('#publication_title').on('keyup', function () {
        var text = translit($(this).val());
        $('#publicaion_url').val(text);
        countSymbols($('#publicaion_url'));
    });

    $('.js-get-percent').on('click',function () {
        var $this = $(this);
        var action = $(this).attr('data-action');
        var checkingText = $(this).attr('data-text');
        if (checkingText) {
            $this.closest('form').find('.js-percent').text(checkingText);
        }
        var text = tinyMCE.activeEditor.getContent();
        $this.attr('disabled', true);
        var req = $.ajax({
            method: 'post',
            url: action,
            data: {'text': text, '_token': CSRF_TOKEN},
        });
        req.done(function(resp) {
            if (resp.success) {
                if (resp.percent) {
                    $this.closest('form').find('[name=uniq_percent]').val(resp.percent);
                    $this.closest('form').find('.js-percent').text(resp.percent);
                }
            } else {
                if (resp.error) {
                    $this.closest('form').find('[name=uniq_percent]').val('');
                    $this.closest('form').find('.js-percent').text(resp.error);
                }
            }
        })
        req.fail(function(error) {
        })
        req.always(function() {
            $this.attr('disabled', false);
        });
    });

    $('.order-content-input').on('change', 'input', function() {
        let $container = $(this).closest('form');
        if($(this).is(':checked')){
            $container.find('.hide-element').hide();
        } else {
            $container.find('.hide-element').show();
        }
    });
    let $parent = $('.order-content-input').closest('form');
    if($('.order-content-input input').is(':checked')){
        $parent.find('.hide-element').hide();
    } else {
        $parent.find('.hide-element').show();
    }
});
tinymce.init({
    selector: '.tinymce',
    relative_urls : false,
    remove_script_host : false,
    convert_urls : true,
    language: 'uk',
    height: '324px',
    plugins: "lists advlist link image media",
    toolbar: 'undo redo | styleselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | link | image ',
    images_upload_url: $('.tinymce').attr('data-image'),
});
if($('#text-editor').length){
    var cLength
    tinymce.init({
        selector: '#text-editor',
        relative_urls : false,
        remove_script_host : false,
        convert_urls : true,
        language: 'uk',
        height: '324px',
        plugins: "lists advlist link image media",
        toolbar: 'undo redo | styleselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | link | image ',
        images_upload_url: $('#text-editor').attr('data-image'),
        init_instance_callback: function (editor) {
            editor.on('SetContent', function (e) {
                getStats();
            });

            function getStats() {
                cLength = editor.contentDocument.body.innerText.match(/\S/g);
                if(cLength !== null) {
                    if(cLength.length == 0) {
                        $('.row-container .for-textarea .current-number').removeClass('green-text').removeClass('red-text').addClass('grey-text');
                        $('.js-get-percent').attr('disabled', true);
                    } else {
                        $('.row-container .for-textarea .current-number').addClass('green-text').removeClass('grey-text').removeClass('red-text');
                        $('.js-get-percent').attr('disabled', false);
                    }

                    $('.row-container .for-textarea .current-number').text(cLength.length);

                    if ($('#text-editor').attr('data-min')) {
                        if (cLength.length <= parseInt($('#text-editor').attr('data-min'))) {
                            $('#text-editor-error').show();
                            $('.row-container .for-textarea .current-number').removeClass('green-text').removeClass('grey-text').addClass('red-text');
                        } else {
                            $('.row-container .for-textarea .current-number').addClass('green-text').removeClass('grey-text').removeClass('red-text');
                            $('#text-editor-error').hide();
                        }
                    }
                    if ($('#text-editor').attr('data-max')) {
                        if (cLength.length >= parseInt($('#text-editor').attr('data-max'))) {
                            $('#text-editor-error').show();
                            $('.row-container .for-textarea .current-number').removeClass('green-text').removeClass('grey-text').addClass('red-text');
                        } else {
                            $('.row-container .for-textarea .current-number').addClass('green-text').removeClass('grey-text').removeClass('red-text');
                            $('#text-editor-error').hide();
                        }
                    }
                } else {
                    $('.row-container .for-textarea .current-number').removeClass('green-text').removeClass('red-text').addClass('grey-text');
                    $('.row-container .for-textarea .current-number').text('0');
                    $('.js-get-percent').attr('disabled', true);
                }
            }
            getStats();

            editor.on('keyup input', function (e) {
                getStats();
            });
        }
    });
}